// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"screen-module--page-wrapper--2V2SN"};